import { API_URL } from '@/lib/types'
import { logout } from './auth'

const AUTH_COOKIE_NAME = 'ses-auth-token'

function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    const cookie = parts.pop()?.split(';').shift()
    return cookie ? decodeURIComponent(cookie) : null
  }
  return null
}

export function getAuthToken(): string | null {
  return getCookie(AUTH_COOKIE_NAME)
}

function handleUnauthorized(): void {
  logout()
  window.location.href = '/login'
}

export async function apiRequest<T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<{ success: boolean; data?: T; error?: string }> {
  try {
    const token = getAuthToken()

    const headers: HeadersInit = {
      ...options.headers,
    }

    if (token) {
      (headers as Record<string, string>)['Authorization'] = `Bearer ${token}`
    }

    if (options.body && !(options.body instanceof FormData)) {
      (headers as Record<string, string>)['Content-Type'] = 'application/json'
    }

    const res = await fetch(`${API_URL}${endpoint}`, {
      ...options,
      headers,
    })

    if (!res.ok) {
      // Handle unauthorized - redirect to login
      if (res.status === 401) {
        handleUnauthorized()
        return { success: false, error: 'Session expired' }
      }

      const error = await res.json().catch(() => ({ error: 'Request failed' }))
      return { success: false, error: error.error || 'Request failed' }
    }

    const data: T = await res.json()
    return { success: true, data }
  } catch (error) {
    console.error('API request error:', error)
    return { success: false, error: 'Network error. Please try again.' }
  }
}
